// extracted by mini-css-extract-plugin
export default {"crossButton":"vB622YDEIKu5iYyPPYLg","crossIcon":"LIfmXXF9nreOGPnv3e5U","placeHolderShimmer":"Qfnv7QdAqcPuDu0LHmJz"};